var map = {
	"./Eyereturn Marketing Logo.png": 2913,
	"./LD Logo.png": 4410,
	"./atb.png": 32,
	"./atbBW.png": 3341,
	"./bmo.png": 2449,
	"./bmoBW.png": 7992,
	"./broker-bay.png": 1375,
	"./broker-bayBW.png": 9974,
	"./cameco-logo.png": 8831,
	"./cameco.png": 2855,
	"./camecoBW.png": 4814,
	"./cibc.png": 6098,
	"./cibcBW.png": 1359,
	"./cogeco.png": 1479,
	"./cogecoBW.png": 2798,
	"./eye-return-marketing.png": 6966,
	"./eye-return-marketingBW.png": 2555,
	"./firstlight-media.png": 1038,
	"./firstlight-mediaBW.png": 9235,
	"./hamilton-health-science.png": 5857,
	"./hamilton-health-scienceBW.png": 488,
	"./keyera.png": 162,
	"./keyeraBW.png": 6447,
	"./pc-financial.png": 3790,
	"./pc-financialBW.png": 2083,
	"./scotiabank.png": 6104,
	"./scotiabankBW.png": 4341,
	"./telus.png": 9508,
	"./telusBW.png": 7001,
	"./therapia.png": 3703,
	"./therapiaBW.png": 5646,
	"./tmx.png": 7564,
	"./tmxBW.png": 4945,
	"./w-games.png": 7390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3804;